import axiosInstance from "../api";
import {
  GET_MEMBERSHIP,
  GET_MEMBERSHIP_BY_ID,
  GET_MY_MEMBERSHIP_DETAILS,
} from "../constants";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";

export const getMembershiplist = (data) => async (dispatch) => {
  const { mtype, checkpermission, billingPeriod } = data;
  try {
    const response = await axiosInstance.get(`membership?mtype=${mtype}&duration_type=${billingPeriod || ""}&checkpermission=${checkpermission || ""}`);
    if (response?.data?.status) {
      dispatch({
        type: GET_MEMBERSHIP,
        membershiplist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getMembershipbyID = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`membership/id?id=${id}`);
    if (response?.data?.status) {
      dispatch({
        type: GET_MEMBERSHIP_BY_ID,
        membershipbyid: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getMyMebershipDetails = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`membership/mine?type=1`);
    if (response?.data?.status) {
      dispatch({
        type: GET_MY_MEMBERSHIP_DETAILS,
        mymebershipdetails: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const buythismembershipandupgrate = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`membership`, data);
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
    } else {
      urtoast(response?.data?.response?.message, 2);
    }
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const cancelMembership = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.put(`membership/cancel`, data);
    if (response?.data?.status) {
      dispatch(getMyMebershipDetails());
      urtoast(response?.data?.response?.message, 1);
    } else {
      urtoast(response?.data?.response?.message, 2);
    }
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

